module.exports = __webpack_public_path__ + "img/node_5.5eacf156.png";